// import devaPriyakumar from "../../assets/faculty/team faculty/2.webp";
import CVJ from "../../assets/faculty/CVJ.webp";
import rameshLoganathan from "../../assets/faculty/ramesh.webp";
import vikramPudi from "../../assets/faculty/team faculty/1.webp";
import bapiRaju from "../../assets/faculty/team faculty/4.webp";
import CKRaju from "../../assets/faculty/team faculty/3.webp";
import gopalaKrishnan from "../../assets/faculty/team faculty/5.webp";
import Ashutosh from "../../assets/faculty/team faculty/AshutoshSir.webp";
import Ganesh from "../../assets/faculty/team faculty/GaneshSir.webp";
import vinodpk from "../../assets/faculty/team faculty/vinod-p-k.webp";
const facData = [
    {
        "ani": "fade-right",
        "img": bapiRaju,
        "name": "Prof Bapi Raju S",
        "details": "Academic Head, IHub-Data, Ph.D (University of Texas, Arlington)"
    },
    // {
    //     "ani": "fade-left",
    //     "img": Jay,
    //     "name": "Jay Mookherje",
    //     "details": "CEO, IHub-Data, Adjunct Faculty- IIITH, PhD (Florida International University)"
    // },
    {
        "ani": "fade-right",
        "img": Ganesh,
        "name": "Dr Veera Ganesh Yalla",
        "details": "CEO, IHub-Data, Adjunct Faculty- IIITH, PhD (University of Kentucky)"
    },
    {
        "ani": "fade-left",
        "img": Ashutosh,
        "name": "Shri Ashutosh Kumar",
        "details": "COO, IHub - Data"
    },
    // {
    //     "ani": "fade-right",
    //     "img": sVerma,
    //     "name": "Varma S. Konala",
    //     "details": "CEO, INAI"
    // },
    {
        "ani": "fade-right",
        "img": vinodpk,
        "name": "Prof Vinod, PK",
        "details": "Head Healthcare"
    },
    {
        "ani": "fade-left",
        "img": CVJ,
        "name": "Prof Jawahar C V",
        "details": "Head Mobility"
    },
    {
        "ani": "fade-left",
        "img": vikramPudi,
        "name": "Prof Vikram Pudi",
        "details": "Head Data Foundation"
    },
    {
        "ani": "fade-right",
        "img": rameshLoganathan,
        "name": "Prof Ramesh Loganathan",
        "details": "Head Startups & Innovation, Professor of Practice, Co-innovations M.E (Anna University, Guindy)"
    },
    {
        "ani": "fade-left",
        "img": CKRaju,
        "name": "Dr C K Raju",
        "details": "Head Programs"
    },
    {
        "ani": "fade-left",
        "img": gopalaKrishnan,
        "name": "Dr Gopalakrishnan B",
        "details": "Scientific Operations"
    }
];

export default facData;
